module.exports = __webpack_public_path__ + "img/pic-2.060b292f.png";